import module from './module';

import ChatViewController from './controllers/ChatViewController';
import CategoryController from './controllers/CategoryController';
import ProductDetailController from './controllers/ProductDetailController';
import ProductListDirectiveController from './directives/ProductListDirective';
import ChatDirectiveController from './directives/ChatDirective';
import ChatCounterDirectiveController from './directives/ChatCounterDirective';
import CatalogService from './services/CatalogService';
import CatalogChatService from './services/ChatService';
import Constants from "../../utils/CommonConstants";
import scopeUtils from "../../utils/scope";

module.controller('Cartonomy.Catalog.ChatViewController', ChatViewController);

module.controller('Cartonomy.Catalog.CategoryController',
    [ '$scope', '$rootScope', '$state', 'Message', '$stateParams', 'OrderSetupService', 'GroupOrder', 'CheckoutService', 'CartService', CategoryController ]);

module.directive('cartonomyCatalogProductList', () => {
        return {
            scope: {
                categoryId: '=',
                searchString: '='
            },
            templateUrl: 'modules/catalog/views/productList.html',
            controller: ProductListDirectiveController
        };
    }
);

module.directive('cartonomyCatalogChat', () => {
    return {
        scope: true,
        template: require('./views/chatDirective.pug'),
        controller: ChatDirectiveController
    };
});

module.service('CatalogService', CatalogService);

module.service('CatalogChatService', CatalogChatService);


module.directive('chatCounter', [ function () {
    return {
        templateUrl: '/modules/catalog/views/chatCounterDirective.html',
        controller: ChatCounterDirectiveController
    };
} ]);

module.directive('chatListener', [ 'CatalogChatService', function (chatService) {
    return {
        link: (scope, element, attr) => {

            let count = chatService.getUnreadMessages();
            if (count && count > 0) {
                element.addClass(attr.chatListener);
            }

            scope.$on(Constants.Events.CHAT_MESSAGE_RECEIVED, (scope, unreadMessages) => {
                if (unreadMessages) {
                    element.addClass(attr.chatListener);
                } else {
                    element.removeClass(attr.chatListener)
                }
                scopeUtils.apply(scope);
            });
        }
    };
} ]);

export default module.name;


// WEBPACK FOOTER //
// ./src/modules/catalog/index.js